import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { whatsappLink } from "@/constants/site";
import { previewFlow } from "@/mocks/criacao-sites";

export default function PreviewExplainer() {
  return (
    <section id="previa-antes-de-decidir" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Veja antes de decidir"
          badgeIcon="ri-eye-line"
          badgeTone="accent"
          title="Imagine o site da sua empresa antes mesmo de contratar"
          description="Você explica o que sua empresa faz, quais serviços oferece e o estilo que deseja. A NXHOST utiliza essas informações para criar uma proposta visual inicial para você conhecer."
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {previewFlow.map((step, index) => (
            <Reveal key={step.title} delay={index * 70} className="h-full">
              <article className="relative flex h-full flex-col rounded-xl border border-background-200 bg-background-100/60 p-5">
                <span className="font-heading text-2xl font-bold text-primary-200">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="mt-3 flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100/70 text-primary-700">
                  <i className={`${step.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-sm font-semibold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{step.description}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-xl border border-background-200 bg-background-100 p-6 text-center sm:flex-row sm:text-left">
            <div>
              <p className="font-heading text-base font-semibold text-foreground-950">
                Você não precisa imaginar como sua empresa pode ficar na internet.
              </p>
              <p className="mt-1 text-sm text-foreground-600">
                Solicite uma prévia inicial sem custo e veja uma proposta concreta para o seu negócio.
              </p>
            </div>
            <a
              href={whatsappLink(
                "Ola! Quero solicitar uma previa inicial sem custo do meu site com a NXHOST."
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-image-add-line text-lg" aria-hidden="true"></i>
              Solicitar minha prévia
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}